/**
 * @packageDocumentation
 * @module f1/asynchronous
 */

export interface Done {
  /**
   * Invoke one task with a value
   *
   * @public
   * @function f1.done
   * @param value
   * @example
   *
   * ```ts
   * f1.done(1) => Promise<R>;
   * ```
   *
   */
  <R>(value: R): Promise<R>;
}

/**
 * @see Done
 */
export default <R>(value: R): Promise<R> => {
  return Promise.resolve(value);
};
